import * as types from '../actions/action-types';

const initialState = {
  error: null,
  form: {},
};

export default function source(state = initialState, action: any) {
  const { form, error, fields } = action;
  switch (action.type) {
    case types.FETCH_FORM:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case types.FETCH_FORM_SUCCESS:
      return {
        ...state,
        form,
        loading: false,
      };
    case types.FETCH_FORM_ERROR:
      return {
        ...state,
        error,
        form: {},
        loading: false,
      };
    case types.UPDATE_FORM:
      return {
        ...state,
        error,
        form: {
          ...fields,
        },
        loading: false,
      };
    default:
      return state;
  }
}
